import { render, staticRenderFns } from "./DbUploader.vue?vue&type=template&id=8f626c6c&scoped=true&"
import script from "./DbUploader.vue?vue&type=script&lang=js&"
export * from "./DbUploader.vue?vue&type=script&lang=js&"
import style0 from "./DbUploader.vue?vue&type=style&index=0&id=8f626c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f626c6c",
  null
  
)

export default component.exports